<template>
    <div>
        <v-row>
            <v-col cols="12" lg="12" sm="12" md="12">
                <div class="d-flex">
                    <v-icon color="#95A1EC">
                        $ice
                    </v-icon>
                    <span class="text-title pl-2">Índice de Conformidade de Enquadramento</span>
                </div>
            </v-col>
        </v-row>
        <v-row>
            <v-col cols="12" md="12" class="mt-2">
                <v-icon class="mr-2" size="16" color="white" style="height: 24px; width: 24px; border-radius: 50%; background-color: #69d7a3;">icon-infohidro-bacia</v-icon>
                <span v-if="location" class="pt-1" style="font-size: 16px;">{{ location.text }}</span>
                <span v-else class="pt-1" style="font-size: 16px;">Estado do Paraná</span>
            </v-col>
        </v-row>
        <v-row>
            <v-col cols="12" md="12" sm="12" lg="12" xl="12">
                <v-card dark class="primary darken-1" style="border-radius: 6px">
                    <v-card-title>
                        <div>
                            <h3 class="subtitle-1 white--text">Selecione o tipo do dado:</h3>
                            <v-tabs class="secondary--text text--lighten-1" v-model="tab"
                                active-class="secondary lighten-1 primary--text text--darken-1"
                                background-color="primary darken-1" slider-color="secondary lighten-1">
                                <v-tab class="tab-item-title" v-for="(item, index) in items" :key="index" :id="item.id">{{
                                    item.title }}</v-tab>
                            </v-tabs>
                        </div>
                        <chart-header v-if="iceData.length > 0 && !showAnimation" :authorize="authorize"
                            @fullscreenChart="fullscreenChart" @printChart="printChart" @exportChart="exportChart($event)"
                            @exportCSV="exportCSV" @exportXLS="exportXLS">

                        </chart-header>
                    </v-card-title>
                    <div v-if="showAnimation" style="height: 300px">
                        <loading-animation @loopComplete="loadAnimationComplete"></loading-animation>
                    </div>
                    <v-card-text v-show="iceData.length > 0 && !showAnimation">

                        <v-tabs-items v-model="tab">
                            <v-tab-item key="tab-graphic">
                                <div class="d-flex flex-column" style=" background-color: #212A35;">
                                    <div id="chartICE"></div>
                                </div>
                            </v-tab-item>

                            <v-tab-item key="tab-table">
                                <v-card dark class="primary darken-1">
                                    <v-card-text>
                                        <div class="d-flex flex-column">
                                            <div class="scroll-table d-flex">
                                                <table>
                                                    <tr class="text-center">
                                                        <th colspan="1" class="fixed-column"></th>
                                                        <th style="color: #95A1EC; font-family: 'Roboto'; font-style: normal; font-weight: 400;font-size: 16.131px;line-height: 26px;"
                                                            v-for="(item, index) in headersTable" :key="index">
                                                            {{ item }}
                                                        </th>
                                                    </tr>

                                                    <tr class="text-center">
                                                        <th class="fixed-column" colspan="1">Total</th>
                                                        <td v-for="(item, index) in iceDataGroupedByTypesItens('total')"
                                                            :key="index" :style="{ 'background-color': item.color }">
                                                            {{ formatNumber(item.value)}}
                                                        </td>
                                                    </tr>
                                                    <tr class="text-center">
                                                        <th class="fixed-column" colspan="1">Físico-químico</th>
                                                        <td v-for="(item, index) in iceDataGroupedByTypesItens('físio-químico')"
                                                            :key="index" :style="{ 'background-color': item.color }">
                                                            {{ formatNumber(item.value)}}
                                                        </td>
                                                    </tr>

                                                    <tr class="text-center">
                                                        <th class="fixed-column" colspan="1">Tóxico</th>
                                                        <td v-for="(item, index) in iceDataGroupedByTypesItens('tóxico')"
                                                            :key="index" :style="{ 'background-color': item.color }">
                                                            {{ formatNumber(item.value)}}
                                                        </td>
                                                    </tr>
                                                    <tr class="text-center">
                                                        <th class="fixed-column" colspan="1">Metais</th>
                                                        <td v-for="(item, index) in iceDataGroupedByTypesItens('metais')"
                                                            :key="index" :style="{ 'background-color': item.color }">
                                                            {{ formatNumber(item.value) }}
                                                        </td>
                                                    </tr>
                                                </table>
                                            </div>
                                            <div class="d-flex pt-2" style=" margin: 0 auto;">
                                                <div class="legend-style pr-4">
                                                    <span
                                                        style="background: rgba(47, 128, 237, 0.3); color: rgba(47, 128, 237, 0.3)"
                                                        class="ellipse-legend"></span>
                                                    <span>Ótimo</span>
                                                </div>
                                                <div class="legend-style pr-4">
                                                    <span
                                                        style="background: rgba(33, 150, 83, 0.3); color: rgba(33, 150, 83, 0.3)"
                                                        class="ellipse-legend"></span>
                                                    <span>Bom</span>
                                                </div>
                                                <div class="legend-style pr-4">
                                                    <span
                                                        style="background: rgba(242, 201, 76, 0.3);; color:rgba(242, 201, 76, 0.3);"
                                                        class="ellipse-legend"></span>
                                                    <span>Regular</span>
                                                </div>
                                                <div class="legend-style pr-4">
                                                    <span
                                                        style="background: rgba(242, 153, 74, 0.3); color: rgba(242, 153, 74, 0.3)"
                                                        class="ellipse-legend"></span>
                                                    <span>Ruim </span>
                                                </div>

                                                <div class="legend-style pr-4">
                                                    <span
                                                        style="background: rgba(160, 41, 3, 0.3); ; color: rgba(160, 41, 3, 0.3); "
                                                        class="ellipse-legend"></span>
                                                    <span>Péssimo</span>
                                                </div>
                                                <div class="legend-style pr-4">
                                                    <span
                                                        style="background: rgba(217, 217, 217, 0.3); color: rgba(217, 217, 217, 0.3)"
                                                        class="ellipse-legend"></span>
                                                    <span>Sem dados</span>
                                                </div>
                                            </div>
                                        </div>
                                    </v-card-text>
                                </v-card>
                            </v-tab-item>
                        </v-tabs-items>

                    </v-card-text>
                    <v-card-text v-show="iceData.length == 0 && !showAnimation">
                        <div style="height: 300px">
                            <span v-if="iceFirstAccess"
                                class="text-card-less-ice">
                                Para ter acesso a um índice selecione uma SIA.
                            </span>
                            <span v-else class="text-card-less-ice">
                                Sem dados para SIA.
                            </span>
                        </div>
                    </v-card-text>
                </v-card>
            </v-col>
        </v-row>
    </div>
</template>
<script>
import { mapGetters } from "vuex";
import Highcharts from "highcharts"
import Highstock from 'highcharts/modules/stock'
import Exporting from 'highcharts/modules/exporting'
import accessibility from "highcharts/modules/accessibility";
import LoadingAnimation from '@/components/common/LoadingAnimation';
import ChartHeader from '@/components/common/ChartHeader';
import {
    rainAndFlowChartAuthorization,
} from '@/helpers/chart_export_authorization';
Exporting(Highcharts)
Highstock(Highcharts)
accessibility(Highcharts);


export default {
    name: "CardICEChart",

    components: {
        LoadingAnimation,
        ChartHeader
    },

    props: {
        location: {
            required: true,
        },
    },
    data: () => ({
        tab: 0,
        chartICE: null,
        items: [
            {
                title: "Gráfico",
                id: 1,
            },
            {
                title: "Dados Tabulados",
                id: 2,
            },
        ],

        loading: false,
        showAnimation: false,
        authorize: [],
    }),

    computed: {
        ...mapGetters(["iceData", "iceFirstAccess"]),
        headersTable() {
            if (this.iceData.length > 0) {
                const headersTable = this.iceData.map(el => el.year).sort()
                return headersTable
            }
            return []
        },
    },

    async created() {
        await this.initializeIce(this.location)

    },

    mounted() {
        this.createICEChart()
        this.authorize = rainAndFlowChartAuthorization;
        window.addEventListener('chartICE', this.handleResize);
    },

    beforeDestroy() {
        window.removeEventListener('chartICE', this.handleResize);
    },

    watch: {
        location(value) {
            if (value) {
                this.initializeIce(value)
            }
        },
        iceData() {
            this.createICEChart();
        },


    },

    methods: {
        formatNumber(val) {
            if (isNaN(val)){
                return val
            }else{
                return new Intl.NumberFormat("pt-BR").format(val);
            }
        },
        handleResize() {
            this.chartICE.reflow();
        },
        loadAnimationComplete() {
            this.showAnimation = this.loading;
        },
        async initializeIce(value) {
            this.showAnimation = true;
            this.loading = true;
            if (value) {
                await this.$store.dispatch("loadSiaDetails", {
                    location_id: value?.locationid,
                });
                const sia = await this.$store.getters.siaDetails;
                await this.$store.dispatch("loadIce", {
                    sia: sia?.locacronymn,
                });
            }

            this.loading = false;
        },
        iceDataGroupedByTypesItens(type) {
            const itens = []
            this.iceData.forEach(el => {
                el.values.forEach((item) => {
                    if (item.tipo == type) {
                        itens.push({
                            color: this.getNameAndColorIce(item.class).rgb,
                            year: el.year,
                            value: item.valor ? item.valor: "Sem dados",
                            class: this.getNameAndColorIce(item.class).name,
                        })
                    }
                })
            });

            itens.sort((a, b) => {
                return a.year - b.year;
            })

            return itens
        },
        getNameAndColorIce(v) {
            if (v != null) {
                if (typeof v == "string") {
                    let value = v.normalize('NFD').replace(/[\u0300-\u036f]/g, '').toLowerCase();
                    if (value.startsWith("boa") || value.startsWith("bom")) {
                        return {
                            hexa: '#219653',
                            rgb: 'rgba(182, 206, 141, 0.3)',
                            name: 'Bom'
                        }
                    }
                    if (value.startsWith("regular")) {
                        return {
                            hexa: '#F2D965',
                            rgb: 'rgba(242, 201, 76, 0.30)',
                            name: 'Regular'
                        }

                    }
                    if (value.startsWith("ruim")) {
                        return {
                            hexa: '#F2D965',
                            rgb: 'rgba(242, 153, 74, 0.30)',
                            name: 'Ruim'

                        }
                    }
                    if (value.startsWith("pessim")) {
                        return {
                            hexa: '#EB5757',
                            rgb: 'rgba(235, 87, 87, 0.3)',
                            name: 'Péssimo'
                        }
                    }
                    if (value.startsWith("otim")) {
                        return {
                            hexa: '#2F80ED',
                            rgb: 'rgba(47, 128, 237, 0.3)',
                            name: 'Ótimo'
                        }
                    }
                }
                else { // number
                    let value = v;
                    if (value > 79 && value <= 94) {
                        return {
                            hexa: '#219653',
                            rgb: 'rgba(182, 206, 141, 0.3)',
                            name: 'Bom'
                        }
                    }
                    if (value > 64 && value <= 79) {
                        return {
                            hexa: '#F2D965',
                            rgb: 'rgba(242, 201, 76, 0.30)',
                            name: 'Regular'
                        }

                    }
                    if (value > 44 && value <= 64) {
                        return {
                            hexa: '#F2D965',
                            rgb: 'rgba(242, 153, 74, 0.30)',
                            name: 'Ruim'

                        }
                    }
                    if (value != null && value <= 44) {
                        return {
                            hexa: '#EB5757',
                            rgb: 'rgba(235, 87, 87, 0.3)',
                            name: 'Péssimo'
                        }
                    }
                    if (value > 94) {
                        return {
                            hexa: '#2F80ED',
                            rgb: 'rgba(47, 128, 237, 0.3)',
                            name: 'Ótimo'
                        }
                    }
                }
            }

            return {
                hexa: '#D9D9D9',
                rgb: 'rgba(217, 217, 217, 0.3)',
                name: 'Sem dados'

            }
        },
        async exportChart(typeFile) {
            await this.chartICE.exportChart({ type: typeFile });
            this.chartICE.text = null

        },
        exportCSV() {
            this.chartICE.downloadCSV();
        },
        exportXLS() {
            this.chartICE.downloadXLS();
        },
        fullscreenChart() {
            const fullscreenControl = new Highcharts.Fullscreen(this.chartICE);
            fullscreenControl.open();
        },
        printChart() {
            this.chartICE.print();
        },
        createICEChart() {
            var labels = [0, 44, 64, 79, 94, 100]
            var count = 0
            const series = [
                {
                    type: "spline",
                    name: 'Total',
                    color: '#8489E8',
                    data: this.iceDataGroupedByTypesItens('total').map(el => el.value)
                },
                {
                    type: "spline",
                    name: 'Físico-químico',
                    color: '#C981EB',
                    data: this.iceDataGroupedByTypesItens('físio-químico').map(el => el.value),

                },
                {
                    type: "spline",
                    name: 'Tóxico',
                    color: '#BE3758',
                    data: this.iceDataGroupedByTypesItens('tóxico').map(el => el.value),
                },
                {
                    type: "spline",
                    name: 'Metais',
                    color: 'rgba(217,217,217,1)',
                    data: this.iceDataGroupedByTypesItens('metais').map(el => el.value),
                },
                {
                    name: 'Ótimo',
                    type: 'column',
                    color: 'rgba(47, 128, 237, 0.3)',
                    events: {
                        legendItemClick: function (e) {
                            e.preventDefault();
                        },
                    },
                },
                {
                    name: 'Bom',
                    type: 'column',
                    color: 'rgba(33, 150, 83, 0.3)',
                    events: {
                        legendItemClick: function (e) {
                            e.preventDefault();
                        },

                        mouseOver: function () {
                            return false
                        },

                        mouseOut: function () {
                            return false
                        }
                    }
                },
                {
                    name: 'Regular',
                    type: 'column',
                    color: 'rgba(242, 201, 76, 0.3)',
                    events: {
                        legendItemClick: function (e) {
                            e.preventDefault();
                        },

                        mouseOver: function () {
                            return false
                        },

                        mouseOut: function () {
                            return false
                        }
                    }
                },
                {
                    name: 'Ruim',
                    type: 'column',
                    color: 'rgba(242, 153, 74, 0.3)',
                    events: {
                        legendItemClick: function (e) {
                            e.preventDefault();
                        },

                        mouseOver: function () {
                            return false
                        },

                        mouseOut: function () {
                            return false
                        }
                    }
                },
                {
                    name: 'Péssimo',
                    type: 'column',
                    color: 'rgba(235, 87, 87, 0.3)',
                    events: {
                        legendItemClick: function (e) {
                            e.preventDefault();
                        },

                        mouseOver: function () {
                            return false;
                        },

                        mouseOut: function () {
                            return false;
                        }
                    }
                }
            ]

            const icon = `  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <rect width="24" height="24" rx="12" fill="#F2C94C" />
                <rect x="7" y="8" width="3" height="11" fill="white" />
                <rect x="15" y="14" width="3" height="5" fill="white" />
                <rect x="11" y="5" width="3" height="14" fill="white" />
            </svg>`;


            const _this = this;
            this.chartICE = Highcharts.chart("chartICE", {
                chart: {
                    backgroundColor: "#212A35",
                },

                title: {
                    text: null
                },

                subtitle: {
                    text: null
                },
                credits: {
                    enabled: false,
                },

                exporting: {
                    enabled: false,
                    filename: `ICE-${this.location ? this.location.text : ''}`,
                    sourceWidth: 1000,

                    chartOptions: {
                        title: {
                            text: `${this.location ? this.location.text : ''}`,
                            style: {
                                color: "#FFFFFF",
                            },
                        },


                    },
                },
                xAxis: {
                    crosshair: true,
                    labels: {
                        format: "{value}",
                        style: {
                            color: "#95A1EC",
                            fontFamily: 'Roboto',
                            fontStyle: 'normal',
                            fontWeight: 400,
                            fontSize: '16.131px',
                            lineWidth: "26.213px"
                        },
                    },
                },
                plotOptions: {
                    series: {
                        pointStart: 2008
                    }
                },
                yAxis: {
                    min: 0,
                    title: {
                        text: "ICE",
                        style: {
                            color: "#FFF",
                            fontFamily: 'Roboto',
                            fontStyle: 'normal',
                            fontWeight: 400,
                            fontSize: "16.131px",

                        },

                    },
                    opposite: false,
                    gridLineColor: '#3A445D',
                    gridLineDashStyle: "Dash",
                    labels: {
                        formatter: function () {
                            count++
                            if(count > 6){

                                count = 1
                            }
                            return labels[count - 1]
                        },
                        style: {
                            color: "#FFF",
                            fontFamily: 'Roboto',
                            fontStyle: 'normal',
                            fontWeight: 400,
                            fontSize: "16.131px",
                        },
                    },

                    plotBands: [{
                        from: 0,
                        to: 25,
                        color: 'rgba(235, 87, 87, 0.3)',
                    },
                    {
                        from: 25,
                        to: 50,
                        color: 'rgba(172, 96, 18, 0.3)',
                    },
                    {
                        from: 50,
                        to: 75,
                        color: 'rgba(242, 217, 101, 0.3)',
                    },
                    {
                        from: 75,
                        to: 100,
                        color: 'rgba(182, 206, 141, 0.3)',
                    },
                    {
                        from: 100,
                        to: 125,
                        color: 'rgba(47, 128, 237, 0.3)',
                    },
                    ],
                },

                legend: {
                    enabled: true,
                    itemStyle: {
                        color: '#FFF',
                        fontWeight: '400',
                        fontFamily: 'Roboto',
                        fontSize: '14px',
                        fontStyle: 'normal',

                    }
                },
                tooltip: {
                    backgroundColor: '#212A35',
                    borderWidth: 0,
                    borderRadius: 5,
                    useHTML: true,
                    headerFormat: '<div style="color:#FFF; font-size: 14.382px; font-family: Roboto; font-style: normal; font-weight: 400; display: flex; flex-direction: column;"><div style="display: flex;">' +
                        `<span>${icon}</span>` +
                        '<b style="padding-top: 5px; padding-left: 5px;">' +
                        `${this.location ? this.location.text : ''}</div></b><div>` +
                        '<div style="display: flex; flex-direction: row;">' +
                        '<table><tr style="color:#FFF; font-size: 13.382px; font-family: Roboto; font-style: normal; font-weight: 400; line-height: 19.299px;"><th colspan="1" style=" text-align: left; padding-left: 8px">' +
                        `{point.key}</th></tr>`
                    ,
                    pointFormatter: function () {
                        return `<tr style="color:#FFF; font-size: 13.382px; font-family: Roboto; font-style: normal; font-weight: 400; line-height: 19.299px;"><td style="padding-left: 10px;">${this.series.name} </td>` +
                            `<td style="text-align: center; padding-left: 10px;"><b>${new Intl.NumberFormat("pt-BR").format(this.y)}</b></td>` +
                            `<td style="text-align: center; padding-left: 10px;"><div style="height: 5px; width: 5px; background-color: ${_this.getNameAndColorIce(this.y).hexa}; border-radius: 50%"></div></td>` +
                            `<td style="text-align: center;  padding-left: 5px;"><b>${_this.getNameAndColorIce(this.y).name}</b></td> </tr>`;
                    },
                    footerFormat: '</table></div>',
                    shared: true,
                },
                series: series
            })

        }
    },

};

</script>


<style scoped>
.text-title {
    font-family: 'Roboto';
    font-style: normal;
    font-weight: 700;
    font-size: 1.3rem;
    line-height: 33px;
    color: #FFFFFF;

}

.text-title-card {
    font-family: 'Roboto';
    font-style: normal;
    font-weight: 700;
    font-size: 1.2rem;
    line-height: 26px;
}

.text-export-card {
    font-family: 'Roboto';
    font-style: normal;
    font-weight: 400;
    font-size: 16px;
    line-height: 20px;
    color: #95A1EC;
    text-transform: none;
}

.text-card {
    font-family: 'Roboto';
    font-style: normal;
    font-weight: 400;
    font-size: 16px;
    line-height: 20px;
    text-transform: none;
}

.text-list-item {
    font-family: 'Roboto';
    font-style: normal;
    font-weight: 700;
    font-size: 13px;
    line-height: 15px;
    color: #95A1EC;
}


.tab-item-title {
    color: var(--v-secondary-lighten1) !important;
    border: 1px solid var(--v-secondary-lighten1);
    text-transform: none;

}

#tab-graphic {
    border-radius: 4.033px 0px 0px 4.033px
}

#tab-table {
    border-radius: 0px 4.033px 4.033px 0px;
}

.headers {
    display: flex;
    flex-direction: row;
    align-items: flex-start;
    padding: 0px;
    width: 774px;
    height: 42px;
}

table {
    border-collapse: collapse;
    min-width: 1500px;
}


th {
    border: 1px solid #95A1EC;
    width: 102px;
    height: 60px;
}

th:first-child {
    border: 0px;
    border-left-style: dashed;
    font-family: 'Roboto';
    font-style: normal;
    font-weight: 400;
    font-size: 14px;
    line-height: 26px;

}

td:last-child {
    border-top-style: dashed;
    border-left-style: inset;
    border-left-width: 1px;
    border-top-width: 1px;
    border-top-color: #95A1EC;
    border-right-style: inset;
    border-right-width: 1px;
    border-left-color: #95A1EC;
    border-right-color: #95A1EC;
    width: 102px;
    height: 60px;

}

td {
    border-top-style: dashed;
    border-left-style: inset;
    border-left-width: 1px;
    border-top-width: 1px;
    border-top-color: #95A1EC;
    border-right-style: dashed;
    border-right-width: 1px;
    border-left-color: #95A1EC;
    border-right-color: #95A1EC;
    width: 102px;
    height: 60px;
    font-family: 'Roboto';
    font-style: normal;
    font-weight: 400;
    font-size: 16.131px;
    line-height: 26px;
    color: #95A1EC;
    /* identical to box height, or 163% */
}

.legend-style {
    display: flex;
    flex-direction: row;
    align-items: center;
    padding: 0px;
    gap: 4px;
}


.ellipse-legend {
    width: 14.2px;
    height: 14.2px;
    border-radius: 50%;
    transform: rotate(-10deg);
    border: 1px solid;
}

.text-card-less-ice {
    color: #95A1EC;
    font-size: 18px;
    font-family: Roboto;
    font-style: italic;
    font-weight: 300;
    line-height: 20px;


}

.scroll-table {
    overflow-x: auto;
}

.fixed-column {
    position: sticky;
    left: 0;
    padding-top: 13px;
    z-index: 1;
    background-color: #212A35;
}
</style>